var _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _rect4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpcomingCalendarOtl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 2V3.5",
    stroke: "#002A69",
    strokeWidth: 1.14,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 2V3.5",
    stroke: "#002A69",
    strokeWidth: 1.14,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 3C13.1046 3 14 3.89543 14 5V10.1738C13.6869 10.0631 13.351 10 13 10C12.8646 10 12.7313 10.009 12.6006 10.0264V4.7998C12.6005 4.57894 12.4211 4.40039 12.2002 4.40039H3.80078C3.5799 4.40039 3.40044 4.57894 3.40039 4.7998V12.2002C3.40055 12.421 3.57997 12.5996 3.80078 12.5996H10.0273C10.0099 12.7306 10 12.8642 10 13C10 13.351 10.0631 13.6869 10.1738 14H4C2.89543 14 2 13.1046 2 12V5C2 3.89543 2.89543 3 4 3H12Z",
    fill: "#002A69"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13 11C14.1046 11 15 11.8954 15 13C15 14.1046 14.1046 15 13 15C11.8954 15 11 14.1046 11 13C11 11.8954 11.8954 11 13 11ZM13.8779 12.3604C13.8006 12.2895 13.6812 12.2947 13.6104 12.3721L12.8223 13.2314L12.3789 12.8223C12.3018 12.7511 12.1815 12.7559 12.1104 12.833C12.0394 12.9101 12.0441 13.0305 12.1211 13.1016L12.7041 13.6396C12.7411 13.6738 12.7905 13.6914 12.8408 13.6895C12.8913 13.6873 12.9395 13.6652 12.9736 13.6279L13.8896 12.6279C13.9605 12.5506 13.9553 12.4312 13.8779 12.3604Z",
    fill: "#002A69"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 5.5,
    width: 2,
    height: 2,
    rx: 0.4,
    fill: "#002A69"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 8.5,
    width: 2,
    height: 2,
    rx: 0.4,
    fill: "#002A69"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 5.5,
    width: 2,
    height: 2,
    rx: 0.4,
    fill: "#002A69"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 8.5,
    width: 2,
    height: 2,
    rx: 0.4,
    fill: "#002A69"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 5.9C10 5.67909 10.1791 5.5 10.4 5.5H11.6C11.8209 5.5 12 5.67909 12 5.9V7.1C12 7.32091 11.8209 7.5 11.6 7.5H10.4C10.1791 7.5 10 7.32091 10 7.1V5.9Z",
    fill: "#002A69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpcomingCalendarOtl);
export default __webpack_public_path__ + "static/media/Upcoming_calendar_otl.a0cec61d9345c9af065b37ecd66a117a.svg";
export { ForwardRef as ReactComponent };